import React from 'react';
import { createLocation, getAllBranches, updateResponse, getStateProvinces } from "../../api/locationApi";

import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form, Input, Label, Button, Row, Col } from 'reactstrap';
import CustomDatePicker from '../CustomDatePicker';
import '../css/EditCreate.css';
import FormValidator from '../FormValidation';
import PopupError from '../PopupError';
import InputTag from '../InputTag';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';

class LocationCreate extends React.Component {

    constructor(props) {
        super(props);
        this.props.route.history.push('/secure/locations');
        this.props.route.history.push(this.props.route.match.url);
        this.validator = new FormValidator([
            {
                field: 'city',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'stateProvinceState',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            }
        ])
        this.state = {
            location: {
                city: '',
                stateProvinceState: '',
                stateProvinceId: '',
                startDate: '',
                endDate: '',
                branchName: '',
                branchId: '',
                synonyms: []
            },

            branches: [],
            stateProvinces: [],
            cancel: false,
            saved: false,
            error: false,
            errorMessage: [],
            locationId: '',
            validation: this.validator.valid(),
        }
        this.onArrayChange = this.onArrayChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);

    onArrayChange(newSynonym) { this.setState(prev => prev.location.synonyms = newSynonym); }

    componentDidMount() {
        console.log("component did mount");
        this.props.getAllBranches(function (result, _this) { _this.getData(result, _this) }, this);
        this.props.getStateProvinces(function (result, _this) { _this.getDataStates(result, _this) }, this);
        this.setState({
            loading: true
        })
    }

    //Shows options of array of branch names. Saves branchId in "id" attribute so we can save branchId state in form.
    renderBranchNames() {
        return this.state.branches.map((branch, index) => {
            return (
                <option id={branch.branchId} key={index}>{branch.name}</option>
            );
        });
    }

    //Shows options of array of state names. Saves stateProvinceId in "id" attribute so we can save StateProvinceId state in form.
    renderStateProvinces() {
        return this.state.stateProvinces.map((stateProvince, index) => {
            return (
                <option id={stateProvince.stateProvinceId} key={index}>{stateProvince.state}</option>
            );
        });
    }

    getData(data, _this) {
        let branches = data.data.data;
        branches.unshift("");
        _this.setState({
            branches: branches,
            loading: false
        })
    }

    getDataStates(data, _this) {
        let stateProvinces = data.data.data;
        stateProvinces.unshift("");
        _this.setState({
            stateProvinces: stateProvinces,
            loading: false
        })
    }

    //calls api when form is submitted
    handleFormSubmit = event => {
        event.preventDefault();

        var updVal = this.state.location;
        updVal.city = updVal.city.trim();
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        this.setState({ location: updVal }, () => {
            const validation = this.validator.validate(this.state.location);
            this.setState({ validation });
            this.submitted = true;
            if (validation.isValid) {
                this.props.createLocation(updVal);
            }
        });
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        console.log(this.state.club);
        if (this.props.updateResult !== prevProps.updateResult) {
            console.log("a response exists");
            var result = this.props.updateResult
            console.log(result, "this is the result");
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    console.log(result.data.success);
                    this.setState(state => ({
                        saved: true,
                        locationId: result.data.data.locationId
                    }));
                } else if (result.data.success === false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                }
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    //Redirects to location list
    handleCancel = () => {
        this.setState({
            cancel: true
        })
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    closeModal() {
        this.setState({ error: false });
    }

    render() {
        const location = this.state.location;


        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/locations`,
                }}
            />;
        }

        if (this.state.saved) {
            return <Redirect
                to={{
                    pathname: `/secure/locationEdit/${this.state.location.branchId}/${this.state.locationId}`,
                    state: { locationId: this.state.locationId }
                }}
            />;
        }

        let validation = this.submitted ?
            this.validator.validate(this.state.location) :
            this.state.validation;
        if (document.querySelector('.nativeDatePicker')) document.querySelector('.nativeDatePicker').style.display = 'none';

        return (

            <div className="card">

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage} />

                <div className="card-header text-center"> Add City</div>
                <div className="card-body fs-12">
                    <Form onSubmit={this.handleSubmit}>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-6">
                                <Row>
                                    <div className="col-md-8">
                                        <Col className={`${validation.city.isInvalid ? 'has-error' : ''}`}>
                                            <Label htmlFor='city' className="required-hint mt-4"><strong>City</strong></Label>
                                            <Input
                                                id="city"
                                                type="input"
                                                name="city"
                                                className="input-editable"
                                                maxLength="150"
                                                required
                                                title=""
                                                value={location.city}
                                                onChange={(e) => { this.isInvalid(e); var x = location; x.city = e.target.value; this.setState({ location: x }) }} />
                                            <span className="help-block">{validation.city.message}</span>
                                        </Col>
                                    </div>
                                    <div className="col-md-4">
                                        <Col className={`${validation.stateProvinceState.isInvalid ? 'has-error' : ''}`}>
                                            <Label htmlFor='stateProvinceState' className="required-hint mt-4"><strong>State</strong></Label>
                                            <label className="select md-input">
                                                <select
                                                    id="stateProvinceState"
                                                    name="stateProvinceState"
                                                    className="form-control input-editable"
                                                    onChange={(e) => {
                                                        let x = location; x.stateProvinceState = e.target.value;
                                                        let y = location; y.stateProvinceId = e.target[e.target.selectedIndex].getAttribute('id');
                                                        this.setState({ location: x, location: y })
                                                    }}
                                                >
                                                    {this.renderStateProvinces()}
                                                </select>
                                            </label>
                                            <span className="help-block">{validation.stateProvinceState.message}</span>
                                        </Col>
                                    </div>
                                </Row>
                                <Col>
                                    <Label htmlFor='synonyms' className="mt-4"><strong>Synonyms</strong></Label>
                                    <InputTag id="synonyms" synonyms={location.synonyms} onArrayChange={this.onArrayChange} />
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Row>
                                    <div className="col-md-12">
                                        <Col className={`${validation.branchName.isInvalid ? 'has-error' : ''}`}>
                                            <Label htmlFor='branchName' className="required-hint mt-4"><strong>Branch </strong></Label>
                                            <label className="select">
                                                <select
                                                    id="branchName"
                                                    name="branchName"
                                                    className="form-control input-editable"
                                                    onChange={(e) => {
                                                        let x = location; x.branchName = e.target.value;
                                                        let y = location; y.branchId = e.target[e.target.selectedIndex].getAttribute('id');
                                                        this.setState({ location: x, location: y })
                                                    }}
                                                >
                                                    {this.renderBranchNames()}
                                                </select>
                                            </label>
                                            <span className="help-block">{validation.branchName.message}</span>
                                        </Col>
                                    </div>
                                    <div className="col-md-6">
                                        <Col className={`${validation.startDate.isInvalid ? 'has-error' : ''}`}>
                                            <Label htmlFor='startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={false}
                                                defValue={location.startDate.substring(0, 10)}
                                                label="Start Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                    </div>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={false}
                                                defValue={location.endDate.substring(0, 10)}
                                                label="End Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                        </Col>
                                    </div>
                                    <Col>
                                        <div className="text-right float-bottom">
                                            <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                            <Button type="submit" onClick={e => this.handleFormSubmit(e)} className={this.state.readOnly ? 'd-none' : 'save-btn'}>SAVE</Button>
                                        </div>
                                    </Col>
                                </Row>

                            </div>
                        </div>

                    </Form>
                </div>
            </div>
        );
    }
}
export default connect(
    state => {
        return {
            updateResult: state.data.updateResult,
            locations: state.data.locations,
            branches: state.data.branches,
            stateProvinces: state.data.stateProvinces
        }
    },
    dispatch => ({
        createLocation: (location) => { dispatch(createLocation(location)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getAllBranches: (callback, context) => { dispatch(getAllBranches(callback, context)) },
        getStateProvinces: (callback, context) => { dispatch(getStateProvinces(callback, context)) }
    }
    )
)(LocationCreate);